<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <orden-venta-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrdenVentaCrud from "./OrdenVentaCrud/OrdenVentaCrud.vue";

export default {
  name: "OrdenVentaManagementPage",
  components: { OrdenVentaCrud },
};
</script>
